(() => {
  'use strict';
  function videoSpec(value) {
    let u; try { u = new URL(value); } catch { return null; }
    if (u.protocol !== 'https:') return null;
    const host = u.hostname.toLowerCase(); let id;
    if (['youtube.com','www.youtube.com','m.youtube.com','youtu.be','www.youtube-nocookie.com'].includes(host)) {
      id = host === 'youtu.be' ? u.pathname.split('/')[1] : u.searchParams.get('v') || u.pathname.match(/^\/(?:shorts|embed|live)\/([^/]+)/)?.[1];
      if (id && /^[\w-]{11}$/.test(id)) return {src:'https://www.youtube-nocookie.com/embed/'+id+'?autoplay=1&rel=0', poster:'https://i.ytimg.com/vi/'+id+'/hqdefault.jpg'};
    }
    if (['vimeo.com','www.vimeo.com','player.vimeo.com'].includes(host)) {
      id = u.pathname.match(/\/(?:video\/)?(\d+)/)?.[1];
      if(id) {const src=new URL('https://player.vimeo.com/video/'+id);const hash=u.searchParams.get('h') || u.pathname.match(/\/\d+\/([\w]+)/)?.[1];if(hash)src.searchParams.set('h',hash);return {src:src.href};}
    }
    return null;
  }
  window.KMAssemblyVideoSpec=videoSpec;
  if (!customElements.get('km-video')) customElements.define('km-video', class extends HTMLElement {
    connectedCallback() {
      if(this.ready)return;this.ready=true;
      const spec=videoSpec(this.dataset.url), button=this.querySelector('button'), message=this.querySelector('[data-video-message]');
      if(!button)return;
      if(!spec){button.hidden=true;message.hidden=false;message.textContent='Use the video link below to watch.';return;}
      if(spec.poster&&!button.querySelector('img')){const img=new Image();img.src=spec.poster;img.alt='';img.loading='lazy';img.width=480;img.height=360;button.prepend(img);}
      button.addEventListener('click',()=>{
        const iframe=document.createElement('iframe');iframe.src=spec.src;iframe.title=this.dataset.title||'Kidsmate video';iframe.allow='autoplay; encrypted-media; fullscreen; picture-in-picture';iframe.allowFullscreen=true;iframe.referrerPolicy='strict-origin-when-cross-origin';
        iframe.addEventListener('error',()=>{message.hidden=false;message.textContent='Unable to load the player. Please use the video link below.';});
        button.replaceWith(iframe);iframe.focus();
      },{once:true});
    }
  });
  function init(scope) {
    scope.querySelectorAll('[data-finder-age]').forEach(async select=>{
      if(select.dataset.ready)return;select.dataset.ready='true';
      const form=select.closest('form'),label=select.closest('[data-age-label]');
      try {
        const url=new URL(form.dataset.filterUrl,location.origin);url.searchParams.set('section_id','km-finder-filters');
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
        const res=await fetch(url.href,{signal:AbortSignal.timeout(7000)});if(!res.ok)throw new Error('Filters unavailable');
        const dom=new DOMParser().parseFromString(await res.text(),'text/html');
        const options=[...dom.querySelectorAll('[data-live-age-options] option[data-param]')];
        if(options.length){options.forEach(o=>select.add(o));select.disabled=false;label.hidden=false;}
      }catch{/* Keyword search stays usable without age configuration. */}
    });
    scope.querySelectorAll('[data-watch-scroll]').forEach(button=>{
      if(button.dataset.ready)return;button.dataset.ready='true';
      button.addEventListener('click',()=>{const track=document.getElementById(button.dataset.watchScroll);if(track)track.scrollBy({left:track.clientWidth*.8*Number(button.dataset.dir),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document));else init(document);
  document.addEventListener('shopify:section:load',e=>init(e.target));
})();
